export default {
  card: {
    display: "flex",
    flexDirection: "column"
  },
  inner: {
    borderWidth: 2,
    borderColor: "#16303D",
    borderStyle: "dashed",
    borderRadius: 5,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    height: 200,
    opacity: 0.6,
    fontWeight: 350,
    fontSize: 22
  },
  outer: {
    margin: "15px 0 0"
  },
  placeholder: {
    fontWeight: 400,
    fontSize: 22,
    letterSpacing: 0.4,
    textTransform: "uppercase",
    color: "#F2B90D",
    textAlign: "center",
    marginBottom: 20
  },
  placeholderIcon: {
    fill: "#F2B90D"
  },
  placeholderContainer: {
    display: "flex",
    width: "100%",
    justifyContent: "center",
    alignItems: "center"
  },
  placeholderInvalid: {
    opacity: 1,
    color: "red"
  },
  placeholderInvalidIcon: {
    fill: "red"
  },
  placeholderValid: {
    opacity: 1,
    color: "green"
  },
  placeholderValidIcon: {
    fill: "green"
  }
};



// WEBPACK FOOTER //
// ./src/components/app/registration/product/inventory/modify/xml/dropzone/styles.js